<template>
  <div class="latest-news-box">
    <!-- <van-swipe :autoplay="2000">
      <van-swipe-item class="banner-item" v-for="(image, index) in bannerList" :key="index" :style="`background-image: url(${image})`"></van-swipe-item>
    </van-swipe> -->
    <div class="mobile-news-list">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list
          v-model="isLoading"
          :finished="finished"
          :finished-text="$t('ArtworkDetail.NoMore')"
          @load="informationList"
        >
          <div class="new-item clearfix" v-for="(item, i) in newsList" :key="i">
            <router-link
              :to="`/news-detail?informationId=${item.informationId}`"
            >
              <img :src="item.logoPath" alt="" class="f-l img" />
              <div class="text-box f-r">
                <div class="title ellipsis-two" v-html="item.chTitle"></div>
                <div class="text-light-gray">{{ item.updateTime }}</div>
              </div>
            </router-link>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>
<!-- Global site tag (gtag.js) - Google Analytics -->
<script async src="https://www.googletagmanager.com/gtag/js?id=G-7CH9447NP2"></script>
<script>
export default {
  data() {
    return {
      bannerList: [
        require("../../../../assets/img/founder-bg.png"),
        require("../../../../assets/img/banner.png"),
        require("../../../../assets/img/about-bg.png"),
      ],
      newsList: [],
      isLoading: false,
      finished: false,
      query: {
        cursor: 0,
        limit: 9,
      },
    };
  },
  created() {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag("js", new Date());

    gtag("config", "G-7CH9447NP2");
  },
  methods: {
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("ArtworkDetail.Refresh"));
        this.newsList = [];
        let data = {
          cursor: 1,
          limit: this.query.limit,
        };
        this.$commonPromise("get", this.$Api.informationList, data).then(
          (res) => {
            if (res.code === 200) {
              this.newsList = res.data.records;
              this.query.cursor = 0;
              this.isLoading = false;
              this.finished = false;
            }
          }
        );
      }, 500);
    },
    informationList() {
      let data = {
        cursor: this.query.cursor + 1,
        limit: this.query.limit,
      };
      this.$commonPromise("get", this.$Api.informationList, data).then(
        (res) => {
          if (res.code === 200) {
            let arr = res.data.records;
            this.newsList.push(...(arr || ""));
            this.query.cursor++;
            this.isLoading = false;
            if (this.query.cursor > res.data.pages) {
              this.finished = true;
            }
          }
        }
      );
    },
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.latest-news-box {
  background-color: #f5f5f5;
  .banner-item {
    height: 420px !important;
    background-size: auto 100%;
    background-repeat: no-repeat;
    background-position: center;
  }
}
</style>